import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const Search = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="Search" {...rest}>
      <path
        d="M15.47 15.53l4.5 4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10 4a6 6 0 110 12 6 6 0 010-12zm0-2a8 8 0 100 16 8 8 0 000-16z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
